import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, filter, map, Subscription } from 'rxjs'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'

@Injectable({providedIn: 'root'})
export class AiChatService {
  private isOpen$ = new BehaviorSubject<boolean>(false)
  private router = inject(Router)
  private subscription = new Subscription()
  private activatedRoute = inject(ActivatedRoute)

  constructor() {
    this.subscription.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          let routes = []
          while (route.firstChild) {
            routes.push(route.firstChild)
            route = route.firstChild
          }
          for (const item of routes.reverse()) {
            if (item.data.value.hasOwnProperty('hide_navbar')) {
              return item
            }
          }
          return route
        })
      ).subscribe(route => {
        if (route.snapshot.data['hide_navbar'] && this.isOpen$.value) {
          this.closeChat()
        }
      })
    )
  }

  toggleChat() {
    this.isOpen$.next(!this.isOpen$.value)
  }

  closeChat() {
    this.isOpen$.next(false)
  }

  openChat() {
    this.isOpen$.next(true)
  }

  get isOpen() {
    return this.isOpen$.asObservable()
  }
} 